import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const StyledShadeToggleButton = styled(ToggleButton)(
  ({ theme }) => `
    border: 1px solid ${theme.palette.brand.disable} !important;
    border-radius: 5px !important;
    margin: 10px 0;
    text-transform: none;
    &.Mui-selected {
      border: 2px solid ${theme.palette.primary.main} !important;
    }
  `,
);

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  () => `
  width: 100%;
  `,
);
